import {
  DATABASE_ERROR,
  API_ERROR,
  ASWER_ERROR,
  SERVER_TIMEOUT_ERROR,
  SERVER_ERROR,
  CONTENT_TOO_LARGE_ERROR,
} from '../../constants';
import { TranslateFn } from '../../hooks/context/useTranslate';

export const getTranslatedErrorMessage = (
  error: Error | null | undefined,
  t: TranslateFn
) => {
  switch (error?.name) {
    case DATABASE_ERROR:
      return t('connectionError.description');
    case API_ERROR:
      return t('apiError');
    case ASWER_ERROR:
      return error.message;
    case SERVER_TIMEOUT_ERROR:
      return t('datasetTimeoutError');
    case SERVER_ERROR:
      return t('datasetServerError');
    case CONTENT_TOO_LARGE_ERROR:
      return t('toasts.contentTooLargeError');
    default:
      return t('datasetClientError');
  }
};
